import { useState } from 'react';
import AccessBarIcon from './AccessBarIcon';
import * as Icons from './Icons';
import AccessBarAccountMobileMenu from './AccessBarAccountMobileMenu';
import AccessBarAccountDesktopMenu from './AccessBarAccountDesktopMenu';
import { useCustomerContext } from '../../../../lib/customer/CustomerContext';
import CustomerModal from '../../Customer/CustomerModal';
import { CustomerFormType } from '../../Customer/types';
import { shouldUseCognito } from '../../Customer/constants';
import CognitoCustomerModal from '../../Customer/CognitoCustomerModal';

export default function AccessBarAccount() {
  const [referenceElement, setReferenceElement] = useState<any>(null);
  const [showAccountDrawer, setShowAccountDrawer] = useState(false);
  const [showAccountModal, setShowAccountModal] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const { customer } = useCustomerContext();

  return (
    <div ref={setReferenceElement}>
      {customer ? (
        // Authenticated
        <>
          <AccessBarIcon
            label="Account"
            onClick={() => setShowAccountModal(true)}
            className="lg:hidden"
          >
            <Icons.Account />
          </AccessBarIcon>
          <AccessBarIcon
            label="Account"
            onClick={() => setShowAccountDrawer(true)}
            className="hidden lg:flex"
          >
            <Icons.Account />
          </AccessBarIcon>

          {/* Account Menu */}
          <AccessBarAccountDesktopMenu
            open={showAccountDrawer}
            setOpen={setShowAccountDrawer}
            referenceElement={referenceElement}
          />

          {/* Account Drawer */}
          <AccessBarAccountMobileMenu
            open={showAccountModal}
            setOpen={setShowAccountModal}
          />
        </>
      ) : (
        // Anonymous
        <>
          <AccessBarIcon
            label="Sign in"
            onClick={() => setShowLoginModal(true)}
          >
            <Icons.Account />
          </AccessBarIcon>

          {/* Login Modal */}
          {shouldUseCognito ? (
            <CognitoCustomerModal
              isOpen={showLoginModal}
              formType={CustomerFormType.LOGIN}
              setIsOpen={setShowLoginModal}
            />
          ) : (
            <CustomerModal
              open={showLoginModal}
              formType={CustomerFormType.LOGIN}
              onClose={() => setShowLoginModal(false)}
              onSuccess={() => setShowLoginModal(false)}
            />
          )}
        </>
      )}
    </div>
  );
}
